'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _memoizeOne = require('memoize-one');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Pagination = require('../Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _Select = require('../Select');

var _Select2 = _interopRequireDefault(_Select);

var _TextField = require('../TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TablePagination = function (_PureComponent) {
  _inherits(TablePagination, _PureComponent);

  function TablePagination() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TablePagination);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TablePagination.__proto__ || Object.getPrototypeOf(TablePagination)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      goToPage: ''
    }, _this.onPageChange = function (_ref2) {
      var selected = _ref2.selected;

      _this.props.onPageChange(selected);
    }, _this.onPageSizeChange = function (e) {
      e && _this.props.onPageSizeChange(e.value);
    }, _this.onGoToPageChange = function (e) {
      _this.setState({
        goToPage: e.target.value
      });
    }, _this.onGoToPageSubmit = function (e) {
      if (e.key === 'Enter') {
        var parsedPage = parseInt(_this.state.goToPage, 10);

        if (!Number.isNaN(parsedPage)) {
          _this.props.onPageChange(parsedPage - 1);
        }
      }
    }, _this.getPageSizeOptions = (0, _memoizeOne2.default)(function (pageSizeOptions) {
      return pageSizeOptions.map(function (pageSize) {
        return {
          label: pageSize,
          value: pageSize
        };
      });
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TablePagination, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          page = _props.page,
          pages = _props.pages,
          pageSize = _props.pageSize,
          pageSizeOptions = _props.pageSizeOptions,
          showPageJump = _props.showPageJump,
          showPageSizeOptions = _props.showPageSizeOptions;
      var goToPage = this.state.goToPage;
      var pageSizeSelect = showPageSizeOptions ? _react2.default.createElement(_Select2.default, {
        clearable: false,
        label: 'Per Page',
        options: this.getPageSizeOptions(pageSizeOptions),
        value: pageSize,
        onChange: this.onPageSizeChange
      }) : null;
      var pageJumpField = showPageJump ? _react2.default.createElement(_TextField2.default, {
        label: 'Go To',
        value: goToPage,
        onChange: this.onGoToPageChange,
        onKeyDown: this.onGoToPageSubmit
      }) : null;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(className, 'rt-pagination')
      }, pageSizeSelect, pageJumpField, _react2.default.createElement(_Pagination2.default, {
        forcePage: page,
        pageCount: pages,
        onPageChange: this.onPageChange
      }));
    }
  }]);

  return TablePagination;
}(_react.PureComponent);

exports.default = TablePagination;
TablePagination.propTypes = {
  className: _propTypes2.default.string,
  page: _propTypes2.default.number.isRequired,
  pages: _propTypes2.default.number.isRequired,
  pageSize: _propTypes2.default.number.isRequired,
  pageSizeOptions: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
  showPageJump: _propTypes2.default.bool,
  showPageSizeOptions: _propTypes2.default.bool,
  onPageChange: _propTypes2.default.func.isRequired,
  onPageSizeChange: _propTypes2.default.func.isRequired
};